var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-box"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":"","id":"img"}}),_vm._v(" "),_c('span',[_vm._v("点击此处上传图片")]),_vm._v(" "),_c('input',{staticClass:"file",attrs:{"type":"file","accept":"image/png,image/jpg,image/jpeg","placeholder":"请选择图片"},on:{"change":function($event){return _vm.change($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84ba6578","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-clip/ImageClip.vue
// module id = null
// module chunks = 